export default class Local {

    constructor() {
        this.id = null;
        this.name = null;
    }

}